// By default, Object.keys is not typed, because typescript only validates the minimal required properties,
// and there can be extra while the type is stills satisfied without throwing an error
export const getObjectKeys = <T extends { [key: string | number]: any }>(
  obj: T,
) => Object.keys(obj) as Array<keyof T>;
